import { initLoadable, type Loadable } from '@/loadingUtils'
import type { Study } from '@pocketprep/types'

type TBundleState = {
    bundles: Loadable<{ [bundleId: string]: Study.Class.BundleJSON } | null>
}

export const getInitialBundleState = (): TBundleState => {
    return {
        bundles: initLoadable(null),
    }
}

const moduleState = getInitialBundleState()

export default moduleState
